import { render, staticRenderFns } from "./solutionsActionForm.vue?vue&type=template&id=c460e07a&scoped=true&"
import script from "./solutionsActionForm.vue?vue&type=script&lang=js&"
export * from "./solutionsActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c460e07a",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QForm,QInput,QBtn,QIcon});
